import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import ProtectedRoute from '../../components/Auth/ProtectedRoute';
import SettingsLayout from './SettingsLayout';
import UserManagement from './UserManagement';
import SystemSettings from './SystemSettings';
import AuditLogs from './AuditLogs';

export default function Settings() {
  return (
    <Routes>
      <Route element={
        <ProtectedRoute requiredPermissions={['manage_system_settings']}>
          <SettingsLayout />
        </ProtectedRoute>
      }>
        <Route index element={<Navigate to="users" replace />} />
        <Route path="users" element={<UserManagement />} />
        <Route path="system" element={<SystemSettings />} />
        <Route path="audit-logs" element={<AuditLogs />} />
      </Route>
    </Routes>
  );
}